const getters = {
  product: (state) => state.product,
  category: (state) => state.category,
};

export default getters;
